<template>
  <v-form ref="frmMain" lazy-validation>
    <v-card>
      <div>
        <v-card-title> {{ skillModel && skillModel.SkillId ? "Edit Technical Skills" : "Add Technical Skills " }} </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <InfoBox title="Add your technical skills here. If you dont see a skill listed, you can submit it manually" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <ComboBoxField
                :readonly="isHiringmanager"
                :rules="[rules.required]"
                id="skill"
                label="Skill"
                placeholder="Start Typing to Search ..."
                :items="skillList"
                showRequired
                outlined
                dense
                item-title="Text"
                item-value="id"
                closable-chips
                v-model="skill.SkillId"
                :returnObject="false"
            /></v-col>
          </v-row>
          <v-row>
            <v-col cols="12 pb-0">
              <span class="f-body-1">Skill Level</span>
            </v-col>
            <v-col cols="12" md="6">
              <v-radio-group :readonly="isHiringmanager" v-model="skill.Level" column :rules="[rules.required]">
                <v-radio label="Basic" value="Basic"></v-radio>
                <v-radio label="Intermediate" value="Intermediate"></v-radio>
                <v-radio label="Advanced" value="Advanced"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <NumberField
                :readonly="isHiringmanager"
                outlined
                dense
                label="Years of Experience"
                v-model="skill.TotalExperienceYears"
                :rules="[rules.required, rules.minNumber(0)]"
                min="0"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <FileUploadField
                v-model="currentFile"
                :readonly="isHiringmanager"
                @change="fileChanged"
                class="mr-3"
                accept=".pdf,.doc,.docx,.png,.jpg"
                dense
                small-chips
                :show-size="showSize"
                outlined
                prepend-icon=""
                label="Your Certificate"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn v-if="!isHiringmanager" :disabled="loading" class="secondary_btn" @click="cancel">Cancel</v-btn>
          <v-btn v-if="!isHiringmanager" class="primary_btn" :loading="loading" @click="saveSkill()" prepend-icon="mdi-check">Save</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-form>
</template>
<script lang="ts">
import { Profile } from "../../../definitions/config";
import { TeammemberSkill } from "../../../models/Teammember";
import UploadProfilePhoto from "../UploadProfilePhoto.vue";
import TeamMemberService from "@/services/TeamMemberService";
import { defineComponent } from "vue";
import FileUploadField from "../../Fields/FileUploadField.vue";
import AutoCompleteField from "../../Fields/AutoCompleteField.vue";
import InfoBox from "../../InfoBox.vue";
import rules from "../../../utils/validations";
export default defineComponent({
  props: ["skillModel", "uploadedCertificateUrl", "isHiringmanager", "tmId", "skillList", "loading"],
  components: {
    UploadProfilePhoto,
    FileUploadField,
    AutoCompleteField,
    InfoBox,
  },
  data() {
    return {
      rules,
      selectedSkill: null,
      currentFile: null as File | null,
      showSize: true,
      skill: {} as TeammemberSkill,
      selectedCertificateUrl: "",
      selectedExperience: 0,
      certificateFile: null as File | null,
      experienceYearList: Profile.Members.SkillExperienceList,
    };
  },
  methods: {
    async fileChanged() {
      var file = this.currentFile;
      this.showSize = true;
      if (this.skill) {
        this.certificateFile = file;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    async saveSkill() {
      const isValid = (await (this.$refs.frmMain as any).validate()).valid;
      if (isValid) {
        if (this.certificateFile) {
          var certificate = await TeamMemberService.uploadSkillCv(this.skill.SkillId, this.certificateFile);
          if (certificate) {
            this.skill.Certificate = certificate;
          }
        }
        this.$emit("saveSkill", this.skill);
      }
    },
  },
  watch: {
    uploadedCertificateUrl(newVal) {
      this.skill.Certificate = newVal;
    },
  },

  mounted() {
    this.skill = { ...this.skillModel };
    if (this.skill.Certificate) {
      var coreFilename = this.skill.Certificate.substring(this.skill.Certificate.lastIndexOf("/") + 1);
      var splitedFilename = coreFilename.split("-");
      var filename = splitedFilename[1];
      if (filename != `${this.tmId}.pdf`) {
        filename = filename.replace(this.tmId, "");
      }
      this.currentFile = new File([], filename);
      this.showSize = false;
    }
  },
});
</script>
